import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'types';
import {
  selectAlertByIssueId,
  selectClearedFieldRefs
} from '../store/slice/selectors';
import type { AlertIssue } from '../store/types';

export const useActiveAlertIssues = (issueId?: string): AlertIssue[] => {
  const alert = useSelector((state: RootState) =>
    issueId ? selectAlertByIssueId(state, issueId) : undefined
  );
  const clearedFieldRefs = useSelector((state: RootState) =>
    issueId ? selectClearedFieldRefs(state, issueId) : []
  );

  return useMemo(() => {
    if (!alert?.issues?.length) return [];
    const dismissed = new Set(alert.dismissedIssueKeys);
    const cleared = new Set(clearedFieldRefs);
    return alert.issues.filter(issue => {
      if (dismissed.has(issue.issueKey)) return false;
      const fieldRefKey = issue.fieldRef || 'null';
      return !cleared.has(fieldRefKey);
    });
  }, [alert, clearedFieldRefs]);
};
